import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { WeldDashboardLeftSectionStyled, WeldDashboardRightSectionStyled } from '~/styled';

export const SuperintendentDashboardStatStyled = styled(Box).attrs({
  mb: { sm: '500' },
  px: { sm: '600' },
  pt: { sm: '500' },
  pb: { sm: '100' },
})`
  ${({ theme }) => css`
    & > :not(:last-child) {
      margin-right: ${theme.spacings[500]};
    }
  `}

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > :not(:last-child) {
      margin-right: ${({ theme }) => theme.spacings[450]};
    }
  }
`;

export const CrewProgressStyled = styled(Box).attrs({ px: { sm: '500' }, py: { sm: '450' }, flexGrow: { sm: 1 } })`
  ${({ theme }) => css`
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 16%);
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[400]};
    overflow-y: auto;
  `};
`;

export const SupDashboardLeftSectionStyled = styled(WeldDashboardLeftSectionStyled)`
  ${({ theme }) => css`
    width: 62%;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      width: 100%;
      margin-right: ${theme.spacings[500]};
    }
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      margin-right: ${theme.spacings[400]};
    }
  `};
`;

export const SupWeldDashboardRightSectionStyled = styled(WeldDashboardRightSectionStyled)`
  ${({ theme }) => css`
    width: 38%;
    @media only screen and (max-width: ${theme.breakpoints.desktop}) {
      width: 35%;
    }
  `};
`;
